"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PageBadgeGroup = void 0;
var pageBadgeGroup_1 = require("./pageBadgeGroup");
Object.defineProperty(exports, "PageBadgeGroup", { enumerable: true, get: function () { return __importDefault(pageBadgeGroup_1).default; } });
